type AssetDimensions = { height: number; width: number };

/**
 * Photos used when neither the block override nor the form-version hero
 * image has an asset. Shared with the info-panel hero so both layouts
 * show the same picture.
 */
const DEFAULT_HERO_IMAGES = {
  large: {
    _ref: "image-803e63f35e1f0e4b72eadd39f0f692a3cf84e8ef-1920x1299-webp",
  },
  small: {
    _ref: "image-f8d69380ffd52d0eeafcd89e60e2242755102c40-1600x1066-png",
  },
} as const;

const CAREGIVER_CTA_OFFSET_PX = 56;

export function resolveAssetDimensions(
  asset: unknown,
  fallback: AssetDimensions,
): AssetDimensions {
  const dimensions = (
    asset as {
      dimensions?: { width?: number; height?: number };
    } | null
  )?.dimensions;

  const width = dimensions?.width;
  const height = dimensions?.height;

  if (typeof width !== "number" || typeof height !== "number") {
    return fallback;
  }

  return width > 0 && height > 0 ? { height, width } : fallback;
}

export function getMobileWrapperMinHeight(
  dimensions: AssetDimensions,
  showCareGiverCTA: boolean,
): string {
  const baseHeight = `calc((100vw * ${dimensions.height}) / ${dimensions.width})`;
  if (!showCareGiverCTA) {
    return baseHeight;
  }
  return `calc(${baseHeight} + ${CAREGIVER_CTA_OFFSET_PX}px)`;
}

export { DEFAULT_HERO_IMAGES };
